import { render, staticRenderFns } from "./RuleActions.vue?vue&type=template&id=f7cb23c6"
import script from "./RuleActions.vue?vue&type=script&setup=true&lang=js"
export * from "./RuleActions.vue?vue&type=script&setup=true&lang=js"
import style0 from "./RuleActions.vue?vue&type=style&index=0&id=f7cb23c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports